const currentYear = (new Date()).getFullYear();
const url = 'http://localhost:3003'

export {
    currentYear,
    url
}